<template>
  <flow-presenter
    :flow-id="flowId"
    v-model:page="pageNumber"
    :close-to="closeRoute"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import FlowPresenter from "@/components/FlowPresenter.vue";

const router = useRouter();
const route = useRoute();
const pageNumber = computed({
  get: () => Number(route.query.page || 1),
  set(value) {
    router.replace({ query: { ...route.query, page: value.toString() } });
  },
});
const flowId = computed(() => route.params.id as string);
const sharedSpaceId = computed(() => {
  if (typeof route.query.sharedSpaceId === "string") {
    return route.query.sharedSpaceId;
  }

  return typeof route.params.spaceId === "string"
    ? route.params.spaceId
    : undefined;
});
const closeRoute = computed(() => {
  if (!sharedSpaceId.value) {
    return undefined;
  }

  // Old sharedSpaceReturnRoute=modern links also return to Classic.
  return { name: "DocumentSpace", params: { id: sharedSpaceId.value } };
});
</script>
